
export default {
    AUTHENTICATION_FAILED: '<span><strong>Login Failed</strong> - Username and/or Password Incorrect. Please check your login information and try again, or <a class="contact-us-error-link" href="||contact-us||">contact us</a>.</span>',
    CONFLICT_SHOP_ID: '<span><strong>Error</strong> - Rewards Account already exists for Direct-Hit credentials entered. Please check your login information and try again, or <a class="contact-us-error-link" href="||contact-us||">contact us</a>.</span>',
    INVALID_IDENTIFIX_CUSTOMER_NUMBER: '<span><strong>Invalid Identifix Customer Number</strong> - Minimum information requirements not met, please contact support at 1-800-745-9649 if you have any questions.</span>',
}


// WEBPACK FOOTER //
// ./src/modules/account-connector/serviceMessages.js